import { VtcStatus } from "../types/users";

export const formatTextToCapitalise = (status?: string | null) => {
  if (!status || status === undefined) return "-";
  return status
    .split("_") // Split by underscore
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join with spaces
};

export const textCapitalise = (text?: string | null) => {
  if (!text || text === undefined) return "-";
  return text.charAt(0).toUpperCase() + text.slice(1); // Capitalize each word
};

export const formatTime = (isoString: string) => {
  const date = new Date(isoString);

  // Format the date and time based on the device's locale and options
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Change this to false if you want a 24-hour format
  });
};

export const carTypes = new Map([
  ["CLASSIC", "Classic"],
  ["GREEN", "Green"],
  ["VAN", "Van"],
  ["MOTOR_BIKE", "Motor Bike"],
  ["TRIKE", "Trike/Van..."],
  ["MEDIUM_TRUCK", "Medium Truck (< 1.5 ton)"],
  ["LARGE_TRUCK", "Large Truck (> 1.5 Ton)"],
]);

export const vehicleTypes = {
  CAR: "Car",
  MOTOR_BIKE: "Motor Bike",
  TRIKE: "Trike/Van...",
  MEDIUM_TRUCK: "Medium Truck (< 1.5 ton)",
  LARGE_TRUCK: "Large Truck (> 1.5 Ton)",
};

const driverTypes: Record<string, string> = {
  normal: "Normal",
  delivery: "Delivery",
  professional: "Shared",
};
export const getDriverTypes = (driver: any) => {
  if (driver.driverType === "delivery") {
    return "Delivery";
  }
  if (driver.driverType === "professional") {
    return "Shared";
  } else {
    if (driver.accept_deliveries) {
      return "Delivery";
    }
    if (driver.accept_shared_rides) {
      return "Shared";
    }
    return "Normal";
  }
};

export const getCurrencySymbol = (country_code: string): React.ReactNode => {
  console.log(country_code);
  switch (country_code) {
    case "ivory-coast":
      return "FCFA";
    case "france":
      return "€";
    case "uk":
      return "£";
    default:
      return "$";
  }
};
